import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.renderDiagrams()
    this.element.addEventListener("mermaid:render", this.renderDiagrams)
  }

  disconnect() {
    this.element.removeEventListener("mermaid:render", this.renderDiagrams)
  }

  renderDiagrams = async () => {
    const codeBlocks = this.element.querySelectorAll('code[data-language="mermaid"]')
    if (codeBlocks.length === 0) return

    try {
      const { default: mermaid } = await import("mermaid")
      mermaid.initialize({ startOnLoad: false, theme: "neutral", securityLevel: "loose" })

      for (const block of codeBlocks) {
        const pre = block.parentElement
        if (!pre || pre.dataset.mermaidRendered) continue

        const source = block.textContent.trim()
        const id = `mermaid-${crypto.randomUUID().slice(0, 8)}`

        try {
          const { svg } = await mermaid.render(id, source)
          const wrapper = document.createElement("div")
          wrapper.className = "mermaid-diagram"
          wrapper.innerHTML = svg
          // Store source for potential re-rendering
          wrapper.dataset.mermaidSource = source
          pre.replaceWith(wrapper)
        } catch {
          // On error, keep the code block visible with error styling
          pre.classList.add("mermaid-error")
          pre.dataset.mermaidRendered = "error"
        }
      }
    } catch {
      // mermaid.js failed to load — code blocks stay as-is
    }
  }
}
